import * as TWEEN from '@tweenjs/tween.js';
import { isInternetExplorer } from '@uipath/angular/utilities';

import { Observable } from 'rxjs';

export const maxSideLength = (width: number, height: number, subCellCount: number, min = 0, max = 0, solution = 0):
    [number, number, number] => {
    if (!subCellCount) { return [0, 0, 0]; }

    // INFO: responsive view can cause element to reach negative sizes 😈
    width = Math.max(width, 1);
    height = Math.max(height, 1);

    max = max || Math.ceil(Math.sqrt(width * height / subCellCount));
    min = min || 1;

    const mid = Math.floor((min + max) / 2);
    const columns = Math.floor(width / mid);
    const rows = Math.floor(height / mid);

    if (Math.abs(min - max) <= 1) {
        return [
            solution,
            columns,
            rows,
        ];
    }

    if (columns * rows >= subCellCount) {
        return maxSideLength(width, height, subCellCount, mid, max, mid);
    }

    return maxSideLength(width, height, subCellCount, min, mid, solution);
};

export const FPS_DELAY = 1000 / (isInternetExplorer() ? 24 : 60);
export const MOUSE_THROTTLE = 1000 / 120;

export const AnimationObserver = <T>(from: T, to: T, duration: number = 1000, easing = TWEEN.Easing.Sinusoidal.Out) =>
    new Observable<T>(subscriber => {
        let animationHandler: number;
        const animationLoop = (time: number) => {
            animationHandler = requestAnimationFrame(animationLoop);
            TWEEN.update(time);
        };

        animationHandler = requestAnimationFrame(animationLoop);

        const tween = new TWEEN.Tween(from)
            .to(to, duration)
            .easing(easing)
            .onUpdate((current: any) => {
                subscriber.next(current);
            })
            .onComplete(() => {
                cancelAnimationFrame(animationHandler);
                subscriber.complete();
            })
            .start();

        return () => {
            tween.stop();
            subscriber.complete();
            cancelAnimationFrame(animationHandler);
        };
    });
